import React from 'react'
import i18next from 'i18next'
import { connect } from 'react-redux'
import { Row, Col, Button, Modal, Form } from 'react-bootstrap'
import hash from 'object-hash'
import { format, parseISO } from 'date-fns'
import ActionsDropdown from 'src/components/system_wide/actions_dropdown'
import ResponsiveTable from 'src/components/system_wide/responsive_table'
import MonthPicker from 'src/components/system_wide/month_picker'
import ReactNumericInput from 'src/components/system_wide/numeric_input'
import SelectBrandModal from 'src/components/system_wide/select_brand_modal'
import { Trans } from 'react-i18next'
import { getClosedContracts, saveClosedContract, deleteClosedContract, resetClosedContracts } from 'src/store/users'
import it from 'date-fns/locale/it'
import { getAllBrands } from 'src/store/brand'

const { t } = i18next

const mstp = state => {
  let { total_closed_contracts, closed_contracts } = state.users
  let { all_brands: brands } = state.brands
  return { total_closed_contracts, closed_contracts, brands }
}

class ContractForm extends React.Component {
  static defaultProps = {
    is_management: false,
    errors: {},
    user: {},
    closeForm: () => {},
  }

  state = {
    id: null,
    period: null,
    num_contract: 0,
    user_data_id: null,
    brand_id: null,

    contract_hash: '',
    show_edit_form: false,
  }

  tableRef = null
  initialHash = null

  constructor(props) {
    super(props)
    this.tableRef = React.createRef()
    this.state.user_data_id = props.user.id
  }

  async componentDidMount() {
    await this.props.dispatch(getAllBrands())
  }

  componentWillUnmount() {
    this.props.dispatch(resetClosedContracts())
    this.props.updateErrors({})
  }

  updateHash = () => {
    // eslint-disable-next-line no-unused-vars
    let { contract_hash, show_edit_form, ...rest } = this.state
    this.setState({ contract_hash: hash(rest) })
  }

  actions = [
    {
      icon: 'fa-edit',
      text: t('actions.edit', 'Modifica'),
      onClick: rowData => {
        let { id, period, num_contract, user_data_id, brand_id } = rowData
        this.initialHash = hash({ id, period, num_contract, user_data_id, brand_id })
        this.setState(
          {
            show_edit_form: true,
            id,
            period,
            num_contract,
            user_data_id,
            brand_id,
          },
          () => this.updateHash()
        )
      },
    },
    {
      icon: 'fa-trash-alt',
      text: t('actions.delete', 'Elimina'),
      onClick: async rowData => {
        let { id } = rowData
        await this.props.dispatch(deleteClosedContract({ id }))
        this.tableRef.current?.refreshData()
      },
    },
  ]

  actionsRenderer = ({ rowData }) => {
    return <ActionsDropdown rowData={rowData} actions={this.actions} />
  }

  renderDetails = ({ rowData: { period, num_contract, brand_id } }) => {
    return (
      <div>
        <div>
          <strong>{t('components.closed_contract_form.period', 'Periodo')}</strong>:{' '}
          {format(parseISO(period), 'MMMM yyyy', { locale: it })}
        </div>
        <div>
          <strong>{t('components.closed_contract_form.num_contract', 'Contratti')}</strong>: {num_contract}
        </div>
        <div>
          <strong>{t('components.closed_contract_form.brand', 'Brand')}</strong>:{' '}
          {this.props?.brands?.find(b => b.id === brand_id)?.name ?? ''}
        </div>
      </div>
    )
  }

  columns = [
    {
      title: '',
      className: 'd-lg-block text-center',
      style: { width: '6%', minWidth: '3rem' },
      data: this.actionsRenderer,
    },
    {
      title: t('components.closed_contract_form.period', 'Periodo'),
      className: 'd-none d-lg-block',
      style: { width: '30%' },
      sortable: true,
      sorting_key: 'period',
      data: ({ rowData: { period } }) => (
        <span className="text-capitalize">{format(parseISO(period), 'MMMM yyyy', { locale: it })}</span>
      ),
    },
    {
      title: t('components.closed_contract_form.num_contract', 'Contratti'),
      className: 'd-none d-lg-block text-center',
      style: { width: '18%' },
      sortable: true,
      data: 'num_contract',
    },
    {
      title: t('components.closed_contract_form.brand', 'Brand'),
      className: 'd-none d-lg-block text-center',
      style: { width: '18%' },
      sortable: false,
      data: ({ rowData }) => {
        return this.props?.brands?.find(b => b.id === rowData.brand_id)?.name ?? ''
      },
    },
    {
      title: t('components.closed_contract_form.details', 'Dettagli'),
      className: 'd-block d-lg-none',
      style: { width: '94%', minWidth: '3rem' },
      data: this.renderDetails,
    },
  ]

  getData = async (index = 0, chunkSize, sortData, filter) => {
    await this.props.dispatch(
      getClosedContracts({ offset: index, limit: chunkSize, sortData, filter, user_id: this.state.user_data_id })
    )
  }

  handleChangeDate = name => contract => {
    let errors = { ...this.props.errors }
    if (name in errors) {
      delete errors[name]
      this.props.updateErrors({ errors })
    }
    this.setState({ [name]: contract.value }, () => this.updateHash())
  }

  onChangeNumericInput = (value, rawValue, { name }) => {
    this.setState({ [name]: value }, () => this.updateHash())
  }

  handleChangeBrands = brands => {
    this.setState({ brand_id: parseInt(brands[0]) }, () => this.updateHash())
  }

  onToggleForm = () => {
    this.setState(
      {
        show_edit_form: !this.state.show_edit_form,
        id: null,
        num_contract: 0,
        period: null,
        brand_id: null,
      },
      () => this.updateHash()
    )
    this.props.updateErrors({})
    this.tableRef.current?.refreshData()
  }

  handleSaveClosedContract = async () => {
    let { show_edit_form, error_msg, error, ...closed_contract } = this.state
    closed_contract.period = closed_contract.period ? format(closed_contract.period, 'yyyy-MM-dd') : ''
    await this.props.dispatch(saveClosedContract({ closed_contract }))
    if (Object.keys(this.props.errors).length === 0) {
      this.tableRef.current?.refreshData()
      this.onToggleForm()
    }
  }

  render() {
    let { show_edit_form, id, period, num_contract, brand_id, contract_hash } = this.state
    return (
      <>
        <div className="flex-row position-relative overflow-auto mb-2">
          <div className="">
            <div className="flex-fill flex-sm-grow-0 flex-sm-shrink-0">
              <Button size="sm" onClick={this.onToggleForm} disabled={this.props.show_form}>
                <i className="fas fa-plus fa-fw text-start me-0" />
                <Trans i18nKey="buttons.add_closed_contract">Aggiungi contratti rilevati</Trans>
              </Button>
            </div>
          </div>
        </div>
        <div className="flex-fill position-relative overflow-auto mb-2">
          <div className=" w-100">
            <div className="d-flex flex-row" style={{ height: '60vh' }}>
              <ResponsiveTable
                ref={this.tableRef}
                className="flex-fill"
                data={this.props?.closed_contracts ?? []}
                getData={this.getData}
                totalRecords={this.props.total_closed_contracts}
                columns={this.columns}
                showMenu={false}
                menuContent={() => null}
                rowClasses={rowData => (rowData.enabled ? '' : `text-muted`)}
                filter={this.state.filter}
              />
            </div>
          </div>
        </div>
        <div className="border-top pt-2">
          <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
            <Trans i18nKey="buttons.close">Chiudi</Trans>
          </Button>
        </div>

        <Modal backdrop="static" centered show={show_edit_form} onHide={this.onToggleForm}>
          <Modal.Header>
            <Modal.Title>
              {!id && (
                <Trans i18nKey="components.users.edit_closed_contract_form.create_modal.title">
                  Crea storico contratti
                </Trans>
              )}
              {id && (
                <Trans i18nKey="components.users.edit_closed_contract_form.edit_modal.title">
                  Modifica storico contratti
                </Trans>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <SelectBrandModal
                user_id={this.props.user.id}
                multiSelection={false}
                required={true}
                selected={brand_id !== null ? [brand_id] : []}
                onChange={this.handleChangeBrands}
              />
            </Form.Group>
            <Form.Group as={Row} className="mb-0 mb-sm-3">
              <Col md="6" className="mb-sm-0 mb-3">
                <Form.Label className=" py-0">
                  <Trans i18nKey="components.users.edit_closed_contract_form.edit_modal.period">Periodo</Trans>
                  <span> *</span>
                </Form.Label>
                <div style={{ width: '15rem' }}>
                  <MonthPicker value={period} onChange={this.handleChangeDate('period')} />
                </div>
              </Col>
              <Col md="6" className="mb-sm-0 mb-3">
                <Form.Group>
                  <Form.Label className=" py-0">
                    <Trans i18nKey="components.users.edit_closed_contract_form.edit_modal.num_closed_contract">
                      Num. contratti
                    </Trans>
                    <span> *</span>
                  </Form.Label>
                  <div style={{ width: '8rem' }}>
                    <ReactNumericInput
                      className="form-control form-control-md"
                      precision={0}
                      min="0"
                      step="1"
                      snap
                      inputMode="decimal"
                      strict
                      name="num_contract"
                      value={num_contract}
                      onChange={this.onChangeNumericInput}
                    />
                  </div>
                </Form.Group>
              </Col>
              {Object.keys(this.props.errors).length > 0 && (
                <Col md="12" className="mt-3 mb-sm-0 mb-3 text-danger">
                  {Object.keys(this.props.errors).map(field => (
                    <em key={field}>{this.props.errors[field]}</em>
                  ))}
                </Col>
              )}
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onToggleForm} variant="secondary">
              <Trans i18nKey="buttons.cancel">Annulla</Trans>
            </Button>
            <Button
              onClick={this.handleSaveClosedContract}
              variant="primary"
              disabled={
                Object.keys(this.props.errors).length > 0 ||
                num_contract === 0 ||
                period === null ||
                this.initialHash === contract_hash
              }>
              <Trans i18nKey="buttons.save">Salva</Trans>
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  }
}
export default connect(mstp, null, null, { forwardRef: true })(ContractForm)
